/* eslint-disable react/react-in-jsx-scope */
import { Skeleton } from "@/components/ui/skeleton";
import { useTranslation } from "react-i18next";

export const PerformanceSkeleton = () => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "program",
  });
  return (
    <>
      <div className="flex  gap-5 mt-5 pl-5 py-5">
        <div className="mr-8">
          <Skeleton className=" w-[100px] h-5 mb-3 bg-[#ecedee]" />
          <p>{t("Prévu")}</p>
          <p>{t("Réalisé")}</p>
          <p>{t("Vérifié/justifié/certifié")}</p>
        </div>
        <div className=" w-full flex flex-col gap-2 mt-5 mr-10">
          <div className=" w-full flex flex-row gap-2">
            {Array.from({ length: 12 }).map((_, index) => (
              <Skeleton
                className=" w-1/12 h-7 rounded-[5px] bg-[#ecedee]"
                key={index}
              />
            ))}
          </div>
          <div className=" w-full flex flex-row gap-2">
            {Array.from({ length: 12 }).map((_, index) => (
              <Skeleton
                className=" w-1/12 h-7 rounded-[5px] bg-[#ecedee]"
                key={index}
              />
            ))}
          </div>
          <div className=" w-full flex flex-row gap-2">
            {Array.from({ length: 12 }).map((_, index) => (
              <Skeleton
                className=" w-1/12 h-7 rounded-[5px] bg-[#ecedee]"
                key={index}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
